export const SkeletonEmpaqueTable = () => {
  return (
    <>
      <div className="block">
        <div className="header">
          <div className="skeleton-text"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
      </div>
      <div className="block">
        <div className="header">
          <div className="skeleton-text"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
      </div>
      <div className="block">
        <div className="header">
          <div className="skeleton-text"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
        <div className="item">
          <div className="left">
            <div className="circle"></div>
            <div className="skeleton-text label"></div>
          </div>
          <div className="skeleton-text value"></div>
        </div>
      </div>
      <style>
        {`
            .block {
                border-radius: 5px;
                margin-bottom: 10px;
                overflow: hidden;
                background: #f1f1f1;
            }

            .header {
                padding: 16px;
                border-bottom: 2px solid black;
            }

            .header .skeleton-text {
                width: 200px;
                height: 25px;
            }

            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5px;
            }

            .left {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            .circle {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: #2979ff;
            }

            .skeleton-text {
                background: #ddd;
                border-radius: 4px;
                animation: pulse 1.5s infinite ease-in-out;
            }

            .label {
                width: 100px;
                height: 25px;
            }

            .value {
                width: 80px;
                height: 16px;
            }

            @keyframes pulse {
                0% { opacity: 1; }
                50% { opacity: 0.4; }
                100% { opacity: 1; }
            }

        `}
      </style>
    </>
  );
};
